import { Theme, css } from '@emotion/react';

export const contentColumn = () => css`
  height: 100%;
  flex: 1;
  overflow-x: auto;
  overflow-y: auto;
  width: calc(100% - var(--aside-width));
`;

export const content = ({ spacing }: Theme) => css`
  height: 100%;
  padding-left: ${spacing(0.5)}px;
  padding-right: ${spacing(2)}px;

  & > * {
    padding-bottom: ${spacing(4)}px;
  }
`;

export const item = ({ colors, spacing }: Theme) => css`
  & + & {
    border-top: 1px solid ${colors.borderLighter};
  }

  & .item-inner {
    display: flex;
    padding-bottom: ${spacing(4)}px;
    padding-top: ${spacing(4)}px;
  }
`;

export const itemInputs = () => css`
  flex: 1;
`;

export const itemActions = ({ spacing }: Theme) => css`
  display: flex;
  flex-direction: column;
  margin-left: ${spacing(1)}px;

  & > * + * {
    margin-top: ${spacing(1)}px;
  }
`;
